import { events as en_events } from "../en/events";

/** events — RU slice (204 keys). */
export const events: Record<keyof typeof en_events, string> = {
  events_title: "События",
  events_nearby: "Рядом",
  events_all: "Все события",
  events_my_events: "Мои события",
  events_create: "Создать событие",
  events_list_empty_title: "Событий не найдено",
  events_list_empty_description: "Загляни позже или создай своё событие",
  events_list_loading: "Загружаем события...",
  events_list_error: "Не удалось загрузить события",
  events_list_search_placeholder: "Поиск событий...",
  events_list_filter_title: "Фильтр событий",
  events_filter_all: "Все",
  events_filter_today: "Сегодня",
  events_filter_this_week: "На этой неделе",
  events_filter_this_month: "В этом месяце",
  events_filter_online: "Онлайн",
  events_filter_in_person: "Вживую",
  events_filter_free: "Бесплатно",
  events_filter_paid: "Платно",
  events_filter_apply: "Применить фильтры",
  events_filter_clear: "Сбросить",
  events_card_free: "Бесплатно",
  events_card_from_price: "От {price}",
  events_card_sold_out: "Билетов нет",
  events_card_tickets_left: "Осталось билетов: {count}",
  events_card_online: "Онлайн-событие",
  events_card_distance: "{distance} миль от тебя",
  events_detail_about: "Описание",
  events_detail_location: "Место",
  events_detail_date_time: "Дата и время",
  events_detail_organizer: "Организатор",
  events_detail_performers: "Участники",
  events_detail_tickets: "Билеты",
  events_detail_get_tickets: "Получить билеты",
  events_detail_buy_ticket: "Купить билет",
  events_detail_reserve_spot: "Забронировать место",
  events_detail_view_ticket: "Мой билет",
  events_detail_share: "Поделиться",
  events_detail_report: "Пожаловаться",
  events_detail_directions: "Проложить маршрут",
  events_detail_online_event: "Это онлайн-событие",
  events_detail_join_online: "Присоединиться онлайн",
  events_status_draft: "Черновик",
  events_status_published: "Опубликовано",
  events_status_cancelled: "Отменено",
  events_status_completed: "Завершено",
  events_form_title: "Название события",
  events_form_title_placeholder: "Придумай название событию",
  events_form_description: "Описание",
  events_form_description_placeholder: "Расскажи, о чём твоё событие...",
  events_form_start_date: "Дата и время начала",
  events_form_end_date: "Дата и время окончания",
  events_form_location: "Место",
  events_form_location_placeholder: "Добавь место проведения",
  events_form_online_event: "Это онлайн-событие",
  events_form_online_url: "Ссылка на событие",
  events_form_online_url_placeholder: "https://zoom.us/...",
  events_form_price: "Цена билета",
  events_form_price_free: "Бесплатное событие",
  events_form_max_tickets: "Максимум билетов",
  events_form_max_tickets_placeholder: "Без ограничений",
  events_form_tags: "Теги события",
  events_form_tags_placeholder: "Выбери теги...",
  events_form_photos: "Фото события",
  events_form_add_photos: "Добавить фото",
  events_form_visibility: "Видимость",
  events_form_visibility_public: "Публичное",
  events_form_visibility_private: "Приватное",
  events_form_visibility_followers: "Только для подписчиков",
  events_form_save_draft: "Сохранить черновик",
  events_form_publish: "Опубликовать событие",
  events_form_update: "Обновить событие",
  events_form_creating: "Создаём событие...",
  events_form_updating: "Обновляем событие...",
  events_validation_title_required: "Укажи название события",
  events_validation_start_date_required: "Укажи дату начала",
  events_validation_end_date_required: "Укажи дату окончания",
  events_validation_end_after_start:
    "Дата окончания должна быть позже даты начала",
  events_validation_location_required: "Для события вживую нужно указать место",
  events_validation_online_url_required: "Для онлайн-события нужна ссылка",
  events_success_created: "Событие создано",
  events_success_updated: "Событие обновлено",
  events_success_published: "Событие опубликовано",
  events_success_cancelled: "Событие отменено",
  events_success_deleted: "Событие удалено",
  events_admin_edit: "Редактировать событие",
  events_admin_manage_tickets: "Управление билетами",
  events_admin_cancel_event: "Отменить событие",
  events_admin_delete_event: "Удалить событие",
  events_admin_cancel_confirm_title: "Отменить событие?",
  events_admin_cancel_confirm_message:
    "Точно хочешь отменить событие? Все, у кого есть билеты, получат уведомление.",
  events_admin_delete_confirm_title: "Удалить событие?",
  events_admin_delete_confirm_message:
    "Точно хочешь удалить событие? Это действие нельзя отменить.",
  tickets_my_tickets: "Мои билеты",
  tickets_upcoming: "Предстоящие",
  tickets_past: "Прошедшие",
  tickets_empty_title: "Билетов пока нет",
  tickets_empty_description:
    "Здесь появятся билеты, когда ты возьмёшь их на события",
  tickets_loading: "Загружаем билеты...",
  tickets_card_active: "Активен",
  tickets_card_used: "Использован",
  tickets_card_cancelled: "Отменён",
  tickets_card_expired: "Просрочен",
  tickets_card_banned: "Заблокирован",
  tickets_card_view: "Открыть билет",
  tickets_card_type_standard: "Стандарт",
  tickets_card_type_vip: "VIP",
  tickets_card_type_early_bird: "Ранняя пташка",
  tickets_card_type_group: "Групповой",
  tickets_qr_title: "Твой билет",
  tickets_qr_scan_instruction: "Покажи этот QR-код на входе",
  tickets_qr_generating: "Создаём QR-код...",
  tickets_qr_error: "Не удалось создать QR-код",
  tickets_qr_refresh: "Обновить QR-код",
  tickets_qr_valid_until: "Действителен до {time}",
  tickets_qr_ticket_id: "ID билета: {id}",
  tickets_purchase_title: "Получить билет",
  tickets_purchase_select_type: "Выбери тип билета",
  tickets_purchase_price: "Цена",
  tickets_purchase_free: "Бесплатно",
  tickets_purchase_confirm: "Подтвердить",
  tickets_purchase_processing: "Обрабатываем...",
  tickets_purchase_success: "Билет успешно оформлен!",
  tickets_purchase_error: "Не удалось оформить билет",
  tickets_purchase_sold_out: "Извини, все билеты раскуплены",
  tickets_purchase_already_have: "У тебя уже есть билет на это событие",
  tickets_cancel_title: "Отменить билет?",
  tickets_cancel_message:
    "Точно хочешь отменить билет? Это действие нельзя отменить.",
  tickets_cancel_confirm: "Отменить билет",
  tickets_cancel_success: "Билет отменён",
  tickets_cancel_error: "Не удалось отменить билет",
  tickets_checkin_title: "Регистрация",
  tickets_checkin_scan: "Сканировать QR-код",
  tickets_checkin_manual: "Ввести ID билета",
  tickets_checkin_success: "Регистрация прошла успешно!",
  tickets_checkin_already_used: "Этот билет уже использован",
  tickets_checkin_invalid: "Недействительный билет",
  tickets_checkin_cancelled: "Этот билет был отменён",
  tickets_checkin_wrong_event: "Этот билет на другое событие",
  tickets_payment_pending: "Ожидает оплаты",
  tickets_payment_paid: "Оплачено",
  tickets_payment_free: "Бесплатно",
  tickets_payment_refunded: "Возвращено",
  events_miniapp_search_placeholder: "Поиск событий...",
  events_miniapp_no_events: "Событий пока нет",
  events_miniapp_no_events_description:
    "Создай событие первым и собери людей вместе.",
  events_miniapp_new_event: "Новое событие",
  events_miniapp_detail: "О событии",
  events_miniapp_buy_ticket: "Купить билет",
  events_miniapp_sold_out: "Билетов нет",
  events_miniapp_free: "Бесплатно",
  events_miniapp_tickets_left: "Осталось билетов: {count}",
  events_miniapp_date: "Дата",
  events_miniapp_price: "Цена",
  events_miniapp_description: "Описание",
  events_miniapp_status_upcoming: "Предстоит",
  events_miniapp_status_ongoing: "Идёт сейчас",
  events_miniapp_status_completed: "Завершено",
  events_miniapp_status_cancelled: "Отменено",
  events_miniapp_organizer: "Организатор",
  events_miniapp_tags: "Теги",
  events_miniapp_address: "Адрес",
  events_miniapp_my_tickets: "Мои билеты",
  events_miniapp_no_tickets: "Билетов пока нет",
  events_miniapp_browse_events: "Смотреть события",
  events_miniapp_ticket_status_active: "Активен",
  events_miniapp_ticket_status_used: "Использован",
  events_miniapp_ticket_status_cancelled: "Отменён",
  events_miniapp_ticket_sales: "Продажа билетов",
  events_miniapp_total_tickets: "Всего",
  events_miniapp_checked_in: "Зарегистрированы",
  events_miniapp_revenue: "Выручка",
  events_miniapp_cancel_event: "Отменить событие",
  events_miniapp_delete_event: "Удалить событие",
  events_miniapp_you_have_ticket: "У тебя есть билет",
  events_miniapp_title_label: "Название события",
  events_miniapp_description_label: "Описание",
  events_miniapp_price_label: "Цена ($)",
  events_miniapp_max_tickets_label: "Максимум билетов",
  events_miniapp_creating: "Создаём...",
  events_miniapp_purchasing: "Оформляем...",
  events_miniapp_company_events: "События компании",
  events_miniapp_view_tickets: "Смотреть билеты",
  events_miniapp_manage: "Управлять",
  events_miniapp_create: "Создать",
  events_miniapp_required_hint: "Поля, отмеченные *, обязательны",
  events_miniapp_error_title_required: "Введите название события",
  events_miniapp_error_date_required: "Выберите дату и время начала",
  events_miniapp_error_date_past: "Время начала должно быть в будущем",
  events_miniapp_business_badge: "Бизнес",
  events_miniapp_hosted_by: "Организатор",
  events_miniapp_events_count: "Событий: {count}",
  events_miniapp_featured: "Рекомендуем",
  events_miniapp_all_events: "Все события",
  events_miniapp_tab_upcoming: "Предстоящие",
  events_miniapp_tab_past: "Прошедшие",
  events_miniapp_tab_tickets: "Билеты",
  events_miniapp_no_past_events: "Прошедших событий нет",
  events_miniapp_view_qr: "Билет / QR-код",
  events_miniapp_ticket_qr_title: "QR-код события",
  events_miniapp_ticket_qr_scan_hint:
    "Покажи этот код на входе, чтобы зарегистрироваться.",
  events_miniapp_ticket_qr_unavailable:
    "QR-код недоступен. Возможно, билет неактивен.",
  events_miniapp_receipt_title: "Чек",
  events_miniapp_your_booking: "Твоё бронирование",
  events_miniapp_event: "Событие",
  events_miniapp_ticket_type: "Билет",
  events_miniapp_price_details: "Детали цены",
  events_miniapp_app_fee: "Комиссия приложения",
  events_miniapp_total: "Итого",
};
